<div class="d-flex flex-row align-items-center">
    <edl-floating-label-container *ngIf="pageSizes.length > 1" label="Per Page" for="pageSize"   class="w-auto mb-2 me-sm-2 mb-sm-0">
        <select id="pageSize" class="form-select" [ngModel]="pageSize" (ngModelChange)="changePageSize($event)">
            <option *ngFor="let size of pageSizes" [ngValue]="size">{{size}}</option>
        </select>
    </edl-floating-label-container>
    <nav aria-label="Pagination" *ngIf="(pagedResponse?.TotalNumberPages ?? 0) > 1">
        <edl-pagination
            [collectionSize]="pagedResponse?.TotalCount ?? 0"
            [(page)]="currentPage"
            [pageSize]="pagedResponse?.Limit ?? 0"
            (pageChange)="onPageChange($event)">
        </edl-pagination>
    </nav>
    <span *ngIf="totalCount > 0" class="ms-2">{{displayStart}} - {{displayEnd}} of {{totalCount}} entries</span>
</div>